// These values are used by default in server-side render,
// unless the developer explicitly specifies:
// * `getEstimatedItemHeight()`
// * `getEstimatedVisibleItemRowsCount()`
// * `getEstimatedInterItemVerticalSpacing()`
export var DEFAULT_VISIBLE_ITEM_ROWS_COUNT = 1; // determines the count of items to render.

export var DEFAULT_ITEM_HEIGHT = 0; // determines the length of the scrollbar, i.e. how much the user can scroll.

export var DEFAULT_INTER_ITEM_VERTICAL_SPACING = 0; // determines the length of the scrollbar, i.e. how much the user can scroll.
//# sourceMappingURL=Layout.defaults.js.map